/** Español */
export default {
  common: {
    loading: 'Cargando…',
    loadingProject: 'Cargando proyecto…',
    cancel: 'Cancelar',
    optional: '(opcional)',
    you: 'tú',
    dash: '—',
    serverError: 'Error {{status}}',
  },
  lang: {
    label: 'Idioma',
  },
  nav: {
    projects: 'Proyectos',
    tecnico: 'Oficina técnica',
    admin: 'Administración',
    logout: 'Cerrar sesión',
  },
  roles: {
    USER: 'Usuario',
    TECNICO: 'Técnico',
    ADMIN: 'Admin',
    badgeAdmin: 'admin',
    badgeTecnico: 'técnico',
  },
  craneType: {
    CINGOLATA: 'Grúa sobre orugas',
    RAGNO: 'Grúa araña',
    AUTOCARRATA: 'Grúa sobre camión',
    TORRE: 'Grúa torre',
  },
  login: {
    titleLogin: 'Acceder al configurador',
    titleRegister: 'Crear una cuenta',
    subtitle: 'Configurador 3D de grúas BGLift',
    name: 'Nombre',
    email: 'Correo electrónico',
    password: 'Contraseña',
    submitLogin: 'Acceder',
    submitRegister: 'Registrarse',
    toggleToRegister: '¿No tienes cuenta? Regístrate',
    toggleToLogin: '¿Ya tienes cuenta? Acceder',
  },
  dashboard: {
    title: 'Tus proyectos',
    subtitle: 'Configuraciones de elevación guardadas',
    newProject: '+ Nuevo proyecto',
    empty: 'Aún no hay proyectos: crea uno para empezar a configurar la grúa.',
    createFirst: 'Crear el primer proyecto',
    byUser: 'de {{name}}',
    updated: 'Actualizado el {{date}}',
    certificatePdf: 'Certificado PDF',
    resend: 'Reenviar para aprobación',
    sendForReview: 'Enviar a la oficina técnica para aprobación',
    openConfigurator: 'Abrir configurador',
    deleteTitle: 'Eliminar proyecto',
    confirmDelete: '¿Eliminar el proyecto “{{name}}”?',
    modalTitle: 'Nuevo proyecto',
    modalSubtitle: 'Elige el tipo y el modelo de grúa: la configurarás en la escena 3D.',
    projectName: 'Nombre del proyecto',
    projectNamePlaceholder: 'Ej. Obra Via Roma',
    craneType: 'Tipo de grúa',
    selectType: 'Selecciona el tipo…',
    model: 'Modelo',
    selectModel: 'Selecciona el modelo…',
    createProject: 'Crear proyecto',
    creating: 'Creando…',
  },
  configurator: {
    backToProjects: 'Volver a los proyectos',
    back: 'Proyectos',
    savedAt: 'Guardado a las {{time}}',
    save: 'Guardar',
    saving: 'Guardando…',
  },
  tecnico: {
    title: 'Oficina técnica',
    subtitle: 'Solicitudes de aprobación de configuración de los clientes',
    empty: 'No hay solicitudes en cola. Las nuevas solicitudes de los clientes aparecerán aquí.',
    requestedBy: 'Solicitud de {{name}} ({{email}}) · enviada el {{date}}',
    assignedTo: 'Asignada a {{name}}',
    openConfiguration: 'Abrir configuración',
    claim: 'Asumir',
    certify: 'Adjuntar PDF y certificar',
    certifying: 'Subiendo…',
  },
  admin: {
    title: 'Administración',
    subtitle: 'Gestión de usuarios y catálogo de modelos de grúa',
    tabUsers: 'Usuarios',
    tabModels: 'Modelos de grúa',
  },
  users: {
    newUser: '+ Nuevo usuario',
    colUser: 'Usuario',
    colRole: 'Rol',
    colStatus: 'Estado',
    colProjects: 'Proyectos',
    colActions: 'Acciones',
    active: 'Activo',
    inactive: 'Desactivado',
    resetPassword: 'Restablecer contraseña',
    deactivate: 'Desactivar',
    reactivate: 'Reactivar',
    delete: 'Eliminar',
    modalTitle: 'Nuevo usuario',
    name: 'Nombre',
    email: 'Correo electrónico',
    password: 'Contraseña',
    role: 'Rol',
    createUser: 'Crear usuario',
    creating: 'Creando…',
    promptResetPassword: 'Nueva contraseña para {{email}} (mín. 6 caracteres):',
    passwordUpdated: 'Contraseña actualizada.',
    confirmDelete: '¿Eliminar definitivamente {{email}}? También se eliminarán sus {{count}} proyectos.',
  },
  models: {
    newModel: '+ Nuevo modelo',
    colCode: 'Código',
    colName: 'Nombre',
    colType: 'Tipo',
    colFile3d: 'Archivo 3D',
    colProjects: 'Proyectos',
    colStatus: 'Estado',
    colActions: 'Acciones',
    active: 'Activo',
    inactive: 'Desactivado',
    deactivate: 'Desactivar',
    activate: 'Activar',
    delete: 'Eliminar',
    confirmDelete: '¿Eliminar el modelo {{code}}?',
    modalTitle: 'Nuevo modelo de grúa',
    modalSubtitle:
      'Se necesitan el archivo 3D (.glb) y el archivo JSON con los datos técnicos (geometría, tabla de carga, configuración por defecto — misma estructura que BR0089.json).',
    code: 'Código',
    codePlaceholder: 'Ej. BR0100',
    craneType: 'Tipo de grúa',
    name: 'Nombre',
    namePlaceholder: 'Ej. BGLift BR0100',
    description: 'Descripción',
    file3d: 'Archivo 3D (.glb)',
    dataFile: 'Datos técnicos (.json)',
    createModel: 'Crear modelo',
    creating: 'Subiendo…',
  },
  controls: {
    realtimeCalc: 'Cálculo de capacidad en tiempo real',
    reset: 'Restablecer',
    resetField: 'Restablecer',
    restore: 'Restaurar',
    legFrontLeft: 'Delantero izquierdo',
    legFrontRight: 'Delantero derecho',
    legRearLeft: 'Trasero izquierdo',
    legRearRight: 'Trasero derecho',
    groupLoad: 'Carga',
    loadWeight: 'Peso elevado',
    maxSwl: 'Capacidad máx. (SWL)',
    loadUtil: 'Utilización de carga',
    groupAerial: 'Grupo aéreo',
    boom: 'Pluma',
    angle: 'Ángulo',
    extensionStroke: 'Carrera de extensión',
    borePressure: 'Presión de fondo',
    rodPressure: 'Presión de vástago',
    turretRotation: 'Rotación de la torreta',
    workRadius: 'Radio de trabajo',
    jib: 'Jib',
    jibAngle: 'Ángulo del jib',
    groupGround: 'Grupo de tierra',
    opening: 'Apertura',
    footHeight: 'Altura del pie',
    knee: 'Rodilla',
    groundHelp:
      'Apertura y Rodilla tienen posiciones fijas (orificios en la máquina), ajustables estabilizador por estabilizador: apertura 0° = plegada a lo largo del chasis, {{deg}}° = totalmente abierta; rodilla 0° = tibia en posición de diseño. Altura del pie: 0 = pie en el suelo, valores positivos = pie sobre un apoyo más alto (sigue apoyado y portante). Las reacciones utilizan las posiciones reales de los pies obtenidas de la apertura, la rodilla y la altura del pie (geometría del plano BGLift); las masas de la máquina siguen siendo orientativas.',
    disclaimer:
      'Prototipo con datos SWL orientativos. Validar siempre con la tabla oficial BGLift y la norma EN 13000 antes del uso en obra.',
  },
  status: {
    safe: 'SEGURO',
    warning: 'ATENCIÓN',
    critical: 'CRÍTICO — STOP',
    shortSafe: 'OK',
    shortWarning: 'ATEN.',
    shortCritical: 'STOP',
    calculating: 'Calculando…',
    radius: 'Radio',
    swl: 'SWL',
    loadUtil: 'Util. carga',
    padUtil: 'Util. placa máx.',
    tippingMargin: 'Margen de vuelco',
    en13000: 'EN 13000 — vuelco al 0 % · umbral de atención al 20 %',
    controls: 'Controles',
  },
  review: {
    requested: 'Enviada a la oficina técnica',
    inReview: 'Asumida por la oficina técnica',
    certified: 'Configuración certificada',
    certificatePdf: 'Certificado PDF',
    sending: 'Enviando…',
    resend: 'Reenviar para aprobación',
    send: 'Enviar a la oficina técnica para aprobación',
  },
  crane3d: {
    loading: 'Cargando…',
  },
}
